import millify from "millify";
import type React from "react";
import { memo } from "react";

interface CustomCursorProps {
	points?: { x: number; y: number }[];
	height?: number;
	stroke: string;
	strokeWidth: number;
	strokeDasharray: string;
	payload?: { [key: string]: number }[];
	maxValue: number;
}

const CustomCursor: React.FC<CustomCursorProps> = memo((props) => {
	const {
		points,
		stroke,
		strokeWidth,
		strokeDasharray,
		height,
		payload,
		maxValue,
	} = props;

	if (!points || points.length === 0) return null;

	const { x } = points[0]; // Get the x position of the cursor
	const chartBottom = height ?? 0; // This is the bottom of the chart

	// Assume you have the maximum value from your data
	const currentValue = payload?.[0]?.value || 0;

	// Calculate the dynamic y position based on the value
	const y = chartBottom - (currentValue / maxValue) * chartBottom;

	console.log("CustomCursor render");

	return (
		<g>
			<line
				id="cursor-line"
				x1={x}
				y1={y} // Start from the graph line's Y position
				x2={x}
				y2={chartBottom} // End at the bottom of the chart
				stroke={stroke}
				strokeWidth={strokeWidth}
				strokeDasharray={strokeDasharray}
			/>
			{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
			<svg
				x={x - 31.5} // Center the SVG horizontally
				y={y - 55} // Position the SVG above the line
				width="63"
				height="39"
				viewBox="0 0 73 39"
				fill="#121212"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g filter="url(#filter0_b_45_140994)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6.69727 1.19141C3.38356 1.19141 0.697266 3.8777 0.697266 7.19141V27.1914C0.697266 30.5051 3.38356 33.1914 6.69726 33.1914H33.2332L35.658 37.3914C36.1199 38.1914 37.2746 38.1914 37.7365 37.3914L40.1614 33.1914H66.6973C70.011 33.1914 72.6973 30.5051 72.6973 27.1914V7.19141C72.6973 3.8777 70.011 1.19141 66.6973 1.19141H6.69727Z"
						fill="#121212"
						strokeWidth="2"
					/>
					<path
						d="M33.2332 33.1914L33.4497 33.0664L33.3775 32.9414H33.2332V33.1914ZM35.658 37.3914L35.4415 37.5164L35.658 37.3914ZM37.7365 37.3914L37.52 37.2664L37.7365 37.3914ZM40.1614 33.1914V32.9414H40.017L39.9449 33.0664L40.1614 33.1914ZM0.947266 7.19141C0.947266 4.01577 3.52163 1.44141 6.69727 1.44141V0.941406C3.24549 0.941406 0.447266 3.73963 0.447266 7.19141H0.947266ZM0.947266 27.1914V7.19141H0.447266V27.1914H0.947266ZM6.69726 32.9414C3.52163 32.9414 0.947266 30.367 0.947266 27.1914H0.447266C0.447266 30.6432 3.24548 33.4414 6.69726 33.4414V32.9414ZM33.2332 32.9414H6.69726V33.4414H33.2332V32.9414ZM35.8745 37.2664L33.4497 33.0664L33.0167 33.3164L35.4415 37.5164L35.8745 37.2664ZM37.52 37.2664C37.1543 37.8997 36.2402 37.8997 35.8745 37.2664L35.4415 37.5164C35.9996 38.4831 37.3949 38.4831 37.953 37.5164L37.52 37.2664ZM39.9449 33.0664L37.52 37.2664L37.953 37.5164L40.3779 33.3164L39.9449 33.0664ZM66.6973 32.9414H40.1614V33.4414H66.6973V32.9414ZM72.4473 27.1914C72.4473 30.367 69.8729 32.9414 66.6973 32.9414V33.4414C70.149 33.4414 72.9473 30.6432 72.9473 27.1914H72.4473ZM72.4473 7.19141V27.1914H72.9473V7.19141H72.4473ZM66.6973 1.44141C69.8729 1.44141 72.4473 4.01577 72.4473 7.19141H72.9473C72.9473 3.73963 70.149 0.941406 66.6973 0.941406V1.44141ZM6.69727 1.44141H66.6973V0.941406H6.69727V1.44141Z"
						fill="#FFFFFF"
						stroke="#FFFFFF"
						strokeWidth="0.4"
					/>
				</g>
				<text
					x="36.5" // Center the text horizontally within the SVG
					y="21" // Position the text vertically within the SVG
					fill="white" // Set the text color
					fontSize="14" // Set the font size
					textAnchor="middle" // Center the text
				>
					{millify(currentValue)}
				</text>
			</svg>
		</g>
	);
});

export default CustomCursor;
